module.exports = {
  id: 26,
  name: 'Wall Sits',
  categories: ['strength', 'legs', 'endurance'],
  sports: [
    'baseball',
    'basketball',
    'boxing',
    'cricket',
    'dance',
    'football',
    'golf',
    'hockey',
    'lacrosse',
    'martial-arts',
    'gymnastics',
    'rugby',
    'soccer',
    'swimming',
    'tennis',
    'track',
    'volleyball',
  ],
  difficulty: 'intermediate',
  skill: 'Strength',
  points: 13,
  instructions:
    'Wall Sits make your legs super strong! Stand with your back against a wall, slide down until your knees are bent like sitting in a chair, and hold that position. Keep your back against the wall and your feet flat on the ground!',
  timedInstructions: [
    // SETUP
    {
      time: 0,
      text: 'Ready to build incredible leg strength? Wall sits will make your legs super powerful!',
    },
    {
      time: 3,
      text: 'Stand with your back against a wall, feet shoulder-width apart!',
    },
    {
      time: 6,
      text: 'Keep your feet flat on the ground and get ready to slide down!',
    },
    {
      time: 9,
      text: '3, 2, 1, START! Slide down like you are sitting in an invisible chair!',
    },
    // SET 1 - 30 second hold
    {
      time: 12,
      text: 'Perfect! Keep your back against the wall, feet shoulder-width apart!',
    },
    {
      time: 15,
      text: 'Your knees should be bent like you are sitting in a chair!',
    },
    {
      time: 18,
      text: 'Keep your feet flat on the ground, do not lift your heels!',
    },
    {
      time: 21,
      text: 'Feel the burn in your thighs! You are building incredible leg strength!',
    },
    {
      time: 24,
      text: 'Keep your back pressed against the wall, stay strong!',
    },
    {
      time: 27,
      text: 'Breathe steady, in and out, you are doing amazing!',
    },
    {
      time: 30,
      text: 'Keep your knees over your toes, maintain perfect form! Try to have your legs as flat as possible in a 90 degree angle.',
    },
    {
      time: 33,
      text: 'Feel the power building in your legs! You are getting stronger!',
    },
    {
      time: 36,
      text: "Keep your core engaged, stay balanced and steady! keep your legs as flat as possible in a 90 degree angle. Like you're sitting on an invisble chair. Magic!",
    },
    {
      time: 39,
      text: 'You are almost halfway there! Keep going strong!',
    },
    {
      time: 42,
      text: 'Keep your back against the wall, feet shoulder-width apart!',
    },
    {
      time: 45,
      text: 'Feel the burn in your thighs! You are building incredible strength!',
    },
    {
      time: 48,
      text: 'Keep your feet flat on the ground, stay balanced! Almost done!',
    },
    {
      time: 51,
      text: 'You are doing amazing! Keep breathing steady!',
    },
    {
      time: 54,
      text: 'Almost done with round one! Stay strong and steady!',
    },
    {
      time: 57,
      text: 'Keep your knees over your toes, maintain perfect form!',
    },
    {
      time: 60,
      text: 'Great job! Stand up and take a deep breath!',
    },
    // REST PERIOD 1 - 25 seconds
    {
      time: 63,
      text: 'Amazing work! Take a deep breath in and out!',
    },
    {
      time: 66,
      text: 'Shake out your legs and get ready for round two!',
    },
    {
      time: 69,
      text: 'You are building incredible leg strength! Ready for round two?',
    },
    {
      time: 72,
      text: ' Get back into position against the wall.',
    },
    {
      time: 75,
      text: '3, 2, 1, START! Slide down like you are sitting in an invisible chair! Slide down as low as you can trying for a flat 90 degree angle. Keep your back against the wall throughout the entire round.',
    },
    // SET 2 - 30 second hold
    {
      time: 78,
      text: 'Perfect! Keep your back against the wall, feet shoulder-width apart!',
    },
    {
      time: 81,
      text: 'Your knees should be bent like you are sitting in a chair!',
    },
    {
      time: 84,
      text: 'Keep your feet flat on the ground, do not lift your heels!',
    },
    {
      time: 87,
      text: 'Feel the burn in your thighs! You are building incredible leg strength!',
    },
    {
      time: 90,
      text: 'Keep your back pressed against the wall, stay strong!',
    },
    {
      time: 93,
      text: 'Breathe steady, in and out, you are doing amazing!',
    },
    {
      time: 96,
      text: 'Keep your knees over your toes, maintain perfect form!',
    },
    {
      time: 99,
      text: 'Feel the power building in your legs! You are getting stronger!',
    },
    {
      time: 102,
      text: 'Keep your core engaged, stay balanced and steady!',
    },
    {
      time: 105,
      text: 'You are almost halfway there! Keep going strong!',
    },
    {
      time: 108,
      text: 'Keep your back against the wall, feet shoulder-width apart!',
    },
    {
      time: 111,
      text: 'Feel the burn in your thighs! You are building incredible strength!',
    },
    {
      time: 114,
      text: 'Keep your feet flat on the ground, stay balanced!',
    },
    {
      time: 117,
      text: 'You are doing amazing! Keep breathing steady!',
    },
    {
      time: 120,
      text: 'Almost done with round two! Stay strong and steady!',
    },
    {
      time: 123,
      text: 'Keep your knees over your toes, maintain perfect form!',
    },
    {
      time: 126,
      text: 'Great job! Stand up and take a deep breath!',
    },
    // REST PERIOD 2 - 25 seconds
    {
      time: 129,
      text: 'Amazing work! Take a deep breath in and out!',
    },
    {
      time: 132,
      text: 'Shake out your legs and get ready for round three!',
    },
    {
      time: 135,
      text: 'You are building incredible leg strength! Ready for round three?',
    },
    {
      time: 138,
      text: 'Remember to keep your back against the wall!',
    },
    {
      time: 141,
      text: '3, 2, 1, START! Slide down like you are sitting in an invisible chair!',
    },
    // SET 3 - 30 second hold
    {
      time: 144,
      text: 'Perfect! Keep your back against the wall, feet shoulder-width apart!',
    },
    {
      time: 147,
      text: 'Your knees should be bent like you are sitting in a chair!',
    },
    {
      time: 150,
      text: 'Keep your feet flat on the ground, do not lift your heels!',
    },
    {
      time: 153,
      text: 'Feel the burn in your thighs! You are building incredible leg strength!',
    },
    {
      time: 156,
      text: 'Keep your back pressed against the wall, stay strong!',
    },
    {
      time: 159,
      text: 'Breathe steady, in and out, you are doing amazing!',
    },
    {
      time: 162,
      text: 'Keep your knees over your toes, maintain perfect form!',
    },
    {
      time: 165,
      text: 'Feel the power building in your legs! You are getting stronger!',
    },
    {
      time: 168,
      text: 'Keep your core engaged, stay balanced and steady!',
    },
    {
      time: 171,
      text: 'You are almost halfway there! Keep going strong!',
    },
    {
      time: 174,
      text: 'Keep your back against the wall, feet shoulder-width apart!',
    },
    {
      time: 177,
      text: 'Feel the burn in your thighs! You are building incredible strength!',
    },
    {
      time: 180,
      text: 'Keep your feet flat on the ground, stay balanced!',
    },
    {
      time: 183,
      text: 'You are doing amazing! Keep breathing steady!',
    },
    {
      time: 186,
      text: 'Almost done with round three! Stay strong and steady!',
    },
    {
      time: 189,
      text: 'Keep your knees over your toes, maintain perfect form!',
    },
    {
      time: 192,
      text: 'Great job! Stand up and take a deep breath!',
    },
    // REST PERIOD 3 - 25 seconds
    {
      time: 195,
      text: 'Amazing work! Take a deep breath in and out!',
    },
    {
      time: 198,
      text: 'Shake out your legs and get ready for the final round!',
    },
    {
      time: 201,
      text: 'You are building incredible leg strength! Ready for the final round?',
    },
    {
      time: 204,
      text: 'Remember to keep your back against the wall!',
    },
    {
      time: 207,
      text: '3, 2, 1, START! Slide down like you are sitting in an invisible chair!',
    },
    // SET 4 - 30 second hold
    {
      time: 210,
      text: 'Perfect! Keep your back against the wall, feet shoulder-width apart!',
    },
    {
      time: 213,
      text: 'Your knees should be bent like you are sitting in a chair!',
    },
    {
      time: 216,
      text: 'Keep your feet flat on the ground, do not lift your heels!',
    },
    {
      time: 219,
      text: 'Feel the burn in your thighs! You are building incredible leg strength!',
    },
    {
      time: 222,
      text: 'Keep your back pressed against the wall, stay strong!',
    },
    {
      time: 225,
      text: 'Breathe steady, in and out, you are doing amazing!',
    },
    {
      time: 228,
      text: 'Keep your knees over your toes, maintain perfect form!',
    },
    {
      time: 231,
      text: 'Feel the power building in your legs! You are getting stronger!',
    },
    {
      time: 234,
      text: 'Keep your core engaged, stay balanced and steady!',
    },
    {
      time: 237,
      text: 'You are almost halfway there! Keep going strong!',
    },
    {
      time: 240,
      text: 'Keep your back against the wall, feet shoulder-width apart!',
    },
    {
      time: 243,
      text: 'Feel the burn in your thighs! You are building incredible strength!',
    },
    {
      time: 246,
      text: 'Keep your feet flat on the ground, stay balanced!',
    },
    {
      time: 249,
      text: 'You are doing amazing! Keep breathing steady!',
    },
    {
      time: 252,
      text: 'Almost done with the final round! Stay strong and steady!',
    },
    {
      time: 255,
      text: 'Keep your knees over your toes, maintain perfect form!',
    },
    {
      time: 258,
      text: 'Great job! Stand up and take a deep breath!',
    },
    // COMPLETION
    {
      time: 261,
      text: 'Incredible work! You just held wall sits for 2 full minutes!',
    },
    {
      time: 264,
      text: 'You are building incredible leg strength and endurance!',
    },
    {
      time: 267,
      text: 'Great job, strength champion! Your legs are getting super powerful!',
    },
  ],
};
